// extracted by mini-css-extract-plugin
export var centered = "_p-6";
export var flexible = "_p-5";
export var footer = "_p-k";
export var footerBorder = "_p-l";
export var header = "_p-c";
export var headerBorder = "_p-d";
export var headerDefault = "_p-g";
export var headerMedium = "_p-h";
export var headerPadding = "_p-e";
export var iconAndTitle = "_p-f";
export var large = "_p-4";
export var largePadding = "_p-a";
export var medium = "_p-3";
export var mediumPadding = "_p-9";
export var modal = "_p-0";
export var modalContainer = "_p-b";
export var noPadding = "_p-7";
export var skinny = "_p-1";
export var small = "_p-2";
export var smallPadding = "_p-8";
export var subtitle = "_p-j";
export var title = "_p-i";